// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wq_a bic_b bic_we"};